module.exports = __webpack_public_path__ + "static/media/strawberry.e9d8709d.png";